const XLSX_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

export async function downloadExcel(
    rows: Record<string, unknown>[],
    filename: string,
    sheetName = 'Sheet1',
): Promise<void> {
    const excel = await import('@mui/x-internal-exceljs-fork');
    const workbook = new excel.Workbook();
    const sheet = workbook.addWorksheet(sheetName);
    const headers = Object.keys(rows[0] ?? {});
    sheet.columns = headers.map(header => ({header, key: header, width: Math.max(14, header.length + 2)}));
    sheet.getRow(1).font = {bold: true};
    sheet.addRows(rows);
    const url = URL.createObjectURL(new Blob([await workbook.xlsx.writeBuffer()], {type: XLSX_TYPE}));
    const a = Object.assign(document.createElement('a'), {href: url, download: filename});
    a.click();
    URL.revokeObjectURL(url);
}
